// Sélecteur de date localisé (format jj/mm/aaaa) cohérent avec l'application.
import React from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";

// value : chaîne ISO "aaaa-mm-jj" (ou "") ; onChange reçoit la même forme.
export function DatePicker({ value, onChange, testId, placeholder = "jj/mm/aaaa" }) {
  const [ouvert, setOuvert] = React.useState(false);
  const date = value ? new Date(`${value}T00:00:00`) : undefined;

  return (
    <Popover open={ouvert} onOpenChange={setOuvert}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full h-10 flex items-center gap-2 rounded-md border border-[#4A8A8A]/30 bg-white px-3 text-sm text-left transition-colors hover:bg-[#E8F4F4]/60 focus:outline-none focus:ring-2 focus:ring-[#4A8A8A]/50"
        >
          <CalendarIcon className="h-4 w-4 text-[#4A8A8A]" />
          {date ? (
            <span className="text-[#1D3D3D]">{format(date, "dd/MM/yyyy", { locale: fr })}</span>
          ) : (
            <span className="text-[#1D3D3D]/40">{placeholder}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={fr}
          selected={date}
          defaultMonth={date}
          captionLayout="dropdown-buttons"
          fromYear={1970}
          toYear={new Date().getFullYear() + 1}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOuvert(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}

export default DatePicker;
